

import { Box, Chip, Divider, Grid, Typography } from "@mui/material"
import { fechaConHora, fechaSinHora } from "../../../helpers/prepararFecha";
import { separadorMillares } from "../../../hooks";




const COLORS = {
    Alistamiento: { bg: "#FFF3CD", text: "#856404", dot: "#F0AD00" },
    Produccion:   { bg: "#D1ECF1", text: "#0C5460", dot: "#17A2B8" },
    Entregado:    { bg: "#D4EDDA", text: "#155724", dot: "#28A745" },
    Pendiente:    { bg: "#F8D7DA", text: "#721C24", dot: "#DC3545" },
};


export const VisualizacionTralletoria = ({ op, items }) => {





    return (

        <Box sx={{ py:2, width:'100%' }}>
            {/* ── HEADER OP ── */}
            <Box sx={{ background: "#1A1D23", borderRadius:3, p:"20px 24px", mb:2 }}>
                <Box sx={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:1, mb:2 }}>
                    <Box>
                        <Typography sx={{ fontSize:12, color:"#9CA3AF", letterSpacing:2 }}>
                            ORDEN DE PEDIDO
                        </Typography>
                        <Typography sx={{ fontSize:28, fontWeight:700, color:"#fff" }}>
                            # {op.op}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                        <Chip size="small" label={op.estado}
                            sx={{ background: COLORS[op.estado]?.bg, color: COLORS[op.estado]?.text, 
                            fontWeight: 700, fontSize: 10 
                        }}/>
                        <Chip size="small" label={op.pago}
                            sx={{ background: op.pago === "PENDIENTE" ? "#F8D7DA" : "#D4EDDA",
                            color: op.pago === "PENDIENTE" ? "#721C24" : "#155724", 
                            fontWeight: 700, fontSize: 10 
                        }} />
                        <Chip size="small" label={op?.view?.toUpperCase()}
                            sx={{ background:"#E0E7FF", color:"#3730A3",
                            fontWeight:700, fontSize:10
                        }}/>
                    </Box>
                </Box>

                <Divider sx={{ borderColor: "#2D3139", mb: 2 }} />

                <Grid container spacing={2}>
                <Grid item xs={6} sm={3}>
                    <Typography sx={{ fontSize:10, color:"#9CA3AF", letterSpacing:1 }}>COMPRA</Typography>
                    <Typography sx={{ fontSize:13, color:"#fff", fontWeight:500 }}>{fechaConHora(op.startOp)}</Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography sx={{ fontSize:10, color:"#9CA3AF", textTransform:"uppercase", letterSpacing:1 }}>Entrega</Typography>
                    <Typography sx={{ fontSize:13, color:"primary.main", fontWeight:600 }}>{fechaSinHora(op.fechaEntrega)}</Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography sx={{ fontSize:10, color:"#9CA3AF", textTransform:"uppercase", letterSpacing:1 }}>Total Orden</Typography>
                    <Typography sx={{ fontSize:13, color:"#fff", fontWeight:700, fontFamily:"monospace" }}>
                        {`$${separadorMillares(op.totalOrden)}`}
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography sx={{ fontSize:10, color:"#9CA3AF", textTransform:"uppercase", letterSpacing: 1 }}>IVA</Typography>
                    <Typography sx={{ fontSize:13, color:"#fff", fontWeight:700, fontFamily:"monospace" }}>
                        {`$${separadorMillares(op.iva)}`}
                    </Typography>
                </Grid>
                </Grid>
            </Box>

            {/* ── ITEMS ── */}
            <Box sx={{ display:"flex", flexDirection:"column", gap:1.5 }}>
                {items.map((item, i) => (
                <Box key={item._id} sx={{ borderRadius: 3, p:"14px 18px", gap:2, alignItems:"center", display:"grid", 
                    gridTemplateColumns: "auto 1fr", border:'2px solid', borderColor:'primary.main'
                }}>

                    {/* Número */}
                    <Box sx={{ width:34, height:34, borderRadius:"50%", fontSize:13, color:"#6B7280", flexShrink:0,
                        background:"#F4F6FA", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, 
                    }}>
                        {i + 1}
                    </Box>

                    {/* Info */}
                    <Box>
                        <Typography fontWeight={600} fontSize={14} mb={0.5}>
                            {item.nombreModificado}
                        </Typography>
                        <Box sx={{ display:"flex", gap:1, flexWrap:"wrap", alignItems:"center" }}>
                            <Chip size="small" label={ item.area }
                                sx={{ background: COLORS[item.area]?.bg, color: COLORS[item.area]?.text,
                                fontWeight: 700, fontSize: 10, height: 22 
                            }}/>
                            {item.color && (
                            <Chip size="small" label={`🎨 ${item.color}`}
                                sx={{ background:"#F4F6FA", color:"#6B7280", fontSize:10, height:22 
                            }}/>
                            )}

                            <Chip size="small" label={`Cant: ${item.cantidad}`}
                                sx={{ background:"#F4F6FA", color:"#6B7280", fontSize:10, height:22,
                                "& .MuiChip-label": {fontWeight:600} 
                            }}/>
                            <Chip size="small" label={item.produccion ? "En producción" : "Sin producción"}
                                sx={{ background:item.produccion ? "#D4EDDA" : "#F4F6FA",
                                color: item.produccion ? "#155724" : "#6B7280",
                                fontSize: 10, height: 22
                            }}/>
                        </Box>
                    </Box>
                </Box>
                ))}

                {/* Total */}
                <Box sx={{ background:"#1A1D23", borderRadius:3, p:"14px 22px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <Typography sx={{ color:"#9CA3AF", fontWeight:500, fontSize:13 }}>
                        {items.length} items · Total
                    </Typography>
                    <Typography sx={{ color:"#fff", fontWeight:700, fontSize:18, fontFamily:"monospace" }}>
                        {`$${separadorMillares(op.totalOrden)}`}
                    </Typography>
                </Box>
            </Box>

        </Box>



    )
}
